import React from "react";
import { useSelector } from "react-redux";
import Comment from "./Comment";

const Comments = () => {
  const handleSubmit = () => {};

  // @todo -> Post comment

  const { loading, video, comments, commentLoading } = useSelector(
    (state) => state.selectedVideo
  );

  return (
    <div className="comments mt-5">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <p>{video.statistics.commentCount} comments</p>
      )}
      <div className="comments-form d-flex w-100 my-2">
        <img
          src="https://yt3.ggpht.com/ytc/AKedOLQt8gORSPO2nNcb4V7D5te_ZVck_fZ-EY4hRGL0Nw=s88-c-k-c0x00ffffff-no-rj"
          alt="usericon"
          className="rounded-circle me-3"
        />
        <form onSubmit={handleSubmit} className="d-flex flex-grow-1">
          <input
            type="text"
            className="flex-grow-1"
            placeholder="Write a comment..."
          />
          <button className="border-0 p-2">Comment</button>
        </form>
      </div>

      {commentLoading ? (
        <p>Loading all comments...</p>
      ) : (
        <div className="comments-list mt-4">
          {comments.map((comment) => (
            <Comment comment={comment.snippet.topLevelComment} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Comments;
